export default {
    manageEvents: {
        name: 'manageEvents',
        tabs: [
            {
                key: 0, value: 'events', path: '/event/', icon: 'fa-regular fa-calendars', checkPermission: (role) => role <= 140,
            },
            {
                key: 1, value: 'portfolios', path: '/portfolio/', checkPermission: (role) => role <= 130,
            },
            {
                key: 2, value: 'divisions', path: '/division/', checkPermission: (role) => role <= 120,
            },
        ],
    },
    questions: {
        name: 'questions',
        tabs: [
            {
                key: 0, value: 'mandatory_questions', path: '/mandatoryquestions/select/', icon: 'fa-regular fa-square-list', checkPermission: (role) => role <= 130,
            },
            {
                key: 1, value: 'non_mandatory_questions', path: '/question/', icon: 'fa-regular fa-list-check', checkPermission: (role) => role <= 110,
            },
        ],
    },
    templates: {
        name: 'templates',
        tabs: [
            {
                key: 0, value: 'surveys', path: '/survey-templates', icon: 'fal fa-clipboard-list', checkPermission: (role) => role <= 170
            },
            {
                key: 1, value: 'sch_userfield_emails', path: '/email-templates', icon: 'fal fa-envelopes', checkPermission: (role) => role <= 170
            },
            {
                key: 2, value: 'presentations', path: '/presentation-templates', icon: 'fal fa-presentation-screen', checkPermission: (role) => role <= 170
            },
        ]
    }
}
